import { useAdminCategoryStore } from '@/infrastructure/store/adminCategoryStore';

export const useAdminCategories = () => {
  const store = useAdminCategoryStore();
  return {
    categories: store.categories,
    isLoading: store.isLoading,
    error: store.error,
    fetchCategories: store.fetchCategories,
    createCategory: store.createCategory,
    updateCategory: store.updateCategory,
    deleteCategory: store.deleteCategory,
    clearError: store.clearError,
  };
};
